import Fields from '@components/fields'
import { Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Stylesubtitle, StyleTitle } from '../style'
import Button from '@components/button'
import {
  ButtonContainer,
  FormContainer,
  LeftColumn,
  ResponsiveRow,
  RightColumn,
} from './style'
import generalSettings from '@apis/generalSettings'
import { toast } from 'react-toastify'

const CommissionSetting = () => {
  const [existing, setExisting] = useState<any | null>(null)

  const fetchCommission = async () => {
    try {
      const data = await generalSettings.getByKey({
        id: 'commission-rate',
        state: 'commissionSetting',
      })

      if (data) setExisting(data)
    } catch (err) {
      console.error('Failed to fetch commission rate', err)
    }
  }

  useEffect(() => {
    fetchCommission()
  }, [])

  const handleSubmit = async (values: { commissionRate: string }) => {
    const payload = {
      key: 'commission-rate',
      value: values.commissionRate,
    }
    if (!existing?.id) {
      payload.group = 'platform-settings'
    }
    try {
      if (existing?.id) {
        await generalSettings.update({
          id: existing.id,
          state: 'commissionSetting',
          data: payload,
        })
        toast.success('Commission settings updated')
      } else {
        await generalSettings.create({
          state: 'commissionSetting',
          data: JSON.stringify(payload),
        })
      }
      // toast.success('Commission rate saved successfully')
    } catch (err) {
      console.error(err)
      // toast.error('Failed to save commission rate')
    }
  }

  return (
    <ResponsiveRow>
      <LeftColumn>
        <StyleTitle>Commission Setting</StyleTitle>
        <Stylesubtitle>
          Admin can manage commission rates applied on bus providers
        </Stylesubtitle>
      </LeftColumn>

      <RightColumn>
        <Formik
          enableReinitialize
          initialValues={{ commissionRate: existing?.value || '' }}
          onSubmit={handleSubmit}
        >
          <FormContainer>
            <Fields.Input
              name="commissionRate"
              label="Commission Rate"
              placeholder="Enter Commission rate"
            />
            <ButtonContainer>
              <Button type="submit" title="Save Settings" justify="end" />
            </ButtonContainer>
          </FormContainer>
        </Formik>
      </RightColumn>
    </ResponsiveRow>
  )
}

export default CommissionSetting
